// OGS Renderer plugin node (plugin.ogs.renderer).
// The terminal lift→present stage of the OGS pipeline, as a blueprint node. Unlike the
// decoder/plücker nodes, OGSRenderer can't be instantiated at import time: it needs the
// scene-bound GaussianLifter + SplatMeshUpdater (which own the host SparkRenderer). The
// OGS engine (OGSModel) constructs the live node with those deps and publishes it via
// isaacSplat.setRendererNode?.(). This module exposes the class + a factory for the
// engine and tests, and stays import-light so a normal page load pays nothing.

import { OGSRenderer } from '../../src/ogs/graph/nodes/OGSRenderer.ts'
import { isaacSplat } from '../../src/ogs/render/splatHandle.js'

const ogsRendererPlugin = {
  // No live node at boot (needs scene deps) — the engine builds + publishes it.
  async init(_host, _manifest) {},
  // Exposed for the engine + tests: build the terminal render node once the engine
  // has its lifter/updater/pose source.
  create(opts) {
    const node = new OGSRenderer(opts)
    isaacSplat.setRendererNode?.(node)
    return node
  },
  OGSRenderer,
}

export default ogsRendererPlugin
